if (!customElements.get('sh-review-carousel')) {
  customElements.define('sh-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sh-review-track');
      this.controls = this.querySelector('.sh-carousel-controls');
      this.dots = this.querySelector('.sh-carousel-dots');
      this.count = this.querySelector('.sh-carousel-count');
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1), options);
      this.track.addEventListener('scroll', () => this.update(), {...options, passive: true});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.resize = new ResizeObserver(() => this.setup());
      this.resize.observe(this.track);
      this.setup();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    setup() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const first = this.track.firstElementChild;
      this.stops = [...new Set([...this.track.children].map(card => Math.round(Math.min(max, card.offsetLeft - (first?.offsetLeft || 0)))))];
      if (!this.stops.length) this.stops = [0];
      this.dots.replaceChildren();
      this.stops.forEach((_, i) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'sh-carousel-dot';
        button.setAttribute('aria-label', `Go to review position ${i + 1}`);
        button.addEventListener('click', () => this.go(i));
        this.dots.append(button);
      });
      this.controls.hidden = max < 2;
      this.update();
    }
    update() {
      this.index = this.stops.reduce((best, x, i) => Math.abs(x - this.track.scrollLeft) < Math.abs(this.stops[best] - this.track.scrollLeft) ? i : best, 0);
      this.querySelector('[data-prev]').disabled = this.index === 0;
      this.querySelector('[data-next]').disabled = this.index === this.stops.length - 1;
      [...this.dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      const value = `${String(this.index + 1).padStart(2, '0')} / ${String(this.stops.length).padStart(2, '0')}`;
      if (this.count.textContent !== value) this.count.textContent = value;
    }
    go(index) {
      this.track.scrollTo({left: this.stops[Math.max(0, Math.min(this.stops.length - 1, index))], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
  });
}
